import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import React from "react";
import {
  checkErrorsSelector,
  currentStepDoubleSleeperMattressBuilderSelector,
  isIncorporateModalOpenSelector,
  isSummaryModalOpenSelector,
  setIsSummaryModalOpen,
} from "../../../redux/slices/customNavigation";
import DoubleFirmnessPreference from "./DoubleFirmnessPreference/DoubleFirmnessPreference";
import DoubleHeightAndWeight from "./DoubleHeightAndWeight/DoubleHeightAndWeight";
import DoublePainPoints from "./DoublePainPoints/DoublePainPoints";
import DoubleSleepStyle from "./DoubleSleepStyle/DoubleSleepStyle";
import FirmnessPreference from "../SingleBedBuilder/Firmness/FirmnessPreference";
import HeightAndWeight from "../SingleBedBuilder/HeightAndWeight/HeightAndWeight";
import IncorporateModal from "../../../components/Modal/IncorporateModal";
import MattressBuilderHeader from "../SingleBedBuilder/common/MattressBuilderHeader";
import PainPoints from "../SingleBedBuilder/PainPoints/PainPoints";
import SleepStyle from "../SingleBedBuilder/SleepStyle/SleepStyle";
import SummaryButton from "../SingleBedBuilder/common/SummaryButton";
import SummaryModal from "../../../components/Modal/SummaryModal";

const DoubleBedBuilder = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const currentStepDoubleSleeperMattressBuilder = useSelector(
    currentStepDoubleSleeperMattressBuilderSelector
  );
  const isIncorporateModalOpen = useSelector(isIncorporateModalOpenSelector);
  const isSummaryModalOpen = useSelector(isSummaryModalOpenSelector);

  return (
    <>
      <IncorporateModal open={isIncorporateModalOpen}></IncorporateModal>
      <SummaryModal open={isSummaryModalOpen}></SummaryModal>
      <MattressBuilderHeader></MattressBuilderHeader>
      <DoubleHeightAndWeight
        currentStepDoubleSleeperMattressBuilder={
          currentStepDoubleSleeperMattressBuilder
        }
      />
      <DoubleSleepStyle
        currentStepDoubleSleeperMattressBuilder={
          currentStepDoubleSleeperMattressBuilder
        }
      />
      <DoublePainPoints
        currentStepDoubleSleeperMattressBuilder={
          currentStepDoubleSleeperMattressBuilder
        }
      ></DoublePainPoints>
      <DoubleFirmnessPreference
        currentStepDoubleSleeperMattressBuilder={
          currentStepDoubleSleeperMattressBuilder
        }
      ></DoubleFirmnessPreference>
      <SummaryButton
        currentStepSingleSleeperMattressBuilder={
          currentStepDoubleSleeperMattressBuilder
        }
      ></SummaryButton>
    </>
  );
};

export default DoubleBedBuilder;
